import {AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {INutritionalProperties} from '../../models/food-group';
import {IStandardDistributionValues} from '../macronutrient-distribution/macronutrient-distribution.component';
import {IMicronutrients} from '../micronutrient-list/micronutrient-list.component';
import {TemplatePlanTypeEnum} from '../../enums/meal-plan';
import {NzModalService} from 'ng-zorro-antd/modal';
import {ICalorieTracking, MealPlanTypeEnum} from '../../models/meal-plans';
import {ISmaeResult} from '../../class/macronutrient-distribution-strategy/enums/smae-result.interface';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {DeviceTypeEnum} from '../../enums/utils';
import {NgScrollbar} from 'ngx-scrollbar';
import {debounceTime, takeWhile} from 'rxjs/operators';
import {MacronutrientDistributionNamespace} from '../../models/meal-plan-builder';
import {IObjectValue} from '../../interfaces/generic';

@Component({
  selector: 'app-toolbar-meal-plan',
  templateUrl: './toolbar-meal-plan.component.html',
  styleUrls: ['./toolbar-meal-plan.component.scss'],
  animations: [fadeInAnimation]
})
export class ToolbarMealPlanComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() showStandardDistribution: boolean;
  @Input() isOfficial: boolean;
  @Input() showMacros: boolean;
  @Input() showMicros: boolean;
  @Input() showTrackingCalories: boolean;
  @Input() showDistributionAlert: boolean;
  @Input() showPatient: boolean;
  @Input() nutritionalPropertiesMealPlan: INutritionalProperties;
  @Input() distributionMessages: string[] = [];
  @Input() standardDistributionValues: IStandardDistributionValues;
  @Input() micronutrients: IMicronutrients[] = [];
  @Input() trackingCaloriesAlert: Partial<ICalorieTracking>;
  @Input() showTemplates: boolean;
  // [0] suma [1] meta // Cambiar por un objeto {macronutrientsSummary, macronutrientsAdequacy}
  @Input() smaeResult: [ISmaeResult, ISmaeResult] | undefined;
  @Input() smaeMacroNutritionalValues: [ISmaeResult, ISmaeResult] | undefined;
  @Input() disabledMealPlanTypes: MealPlanTypeEnum[] = [];
  @Input() viewSMAESteps = false; // double binding with emitViewSMAESteps property
  @Input() categoryIngredientsCount: IObjectValue<MacronutrientDistributionNamespace.ISmaePortionComparison> = {};

  get hasValuesCategoryIngredientsCount(): boolean {

    type ISmaePortionComparison =  MacronutrientDistributionNamespace.ISmaePortionComparison;
    const map = ([_, smaePortion]: [string, ISmaePortionComparison]): ISmaePortionComparison => ({...smaePortion});
    const filter = (item: ISmaePortionComparison) => item.smaePortion > 0 && item.valueSmaeTable > 0;
    const items: ISmaePortionComparison[] = Object.entries(this.categoryIngredientsCount ?? {}).map(map).filter(filter);
    return items.length > 0;
  }
  @Input('mealPlanTypeSelectedOverride') set setMealPlanTypeSelectedOverride(type: MealPlanTypeEnum) {
    if (!type) return;
    this.mealPlanType = {
      types: MealPlanTypeEnum,
      selected: type,
    };
  }

  @Output() emitTemplatePlanType: EventEmitter<TemplatePlanTypeEnum> = new EventEmitter<TemplatePlanTypeEnum>();
  @Output() emitMealPlanType: EventEmitter<MealPlanTypeEnum> = new EventEmitter<MealPlanTypeEnum>();
  @Output() emitViewSMAESteps: EventEmitter<boolean> = new EventEmitter<boolean>(); // double binding with emitViewSMAESteps viewSMAESteps
  @Output() emitSMAEViewPeriods: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('toolbarContent') toolbarContent: ElementRef;
  @ViewChild('ngScrollbar') scrollbarRef: NgScrollbar;


  destroy = false;


  templatePlanTypeEnum = TemplatePlanTypeEnum;
  templatePlanTypeSelected: TemplatePlanTypeEnum = TemplatePlanTypeEnum.CUSTOM;

  mealPlanType: {
    selected: MealPlanTypeEnum,
    types: typeof MealPlanTypeEnum,
  };
  showNextArrow: boolean;
  showPrevArrow: boolean;
  isDesktop: boolean;
  timeOutResize: any;
  constructor(
    private nzModalService: NzModalService,
    private utilitiesService: UtilitiesService,
    private modal: NzModalService,
  ) {}

  ngOnInit(): void {
    this.mealPlanType = this.mealPlanType ? this.mealPlanType : {
      selected: MealPlanTypeEnum.SMAE,
      types: MealPlanTypeEnum,
    };
    this.isDesktop = this.getDeviceDesktop();
  }

  ngAfterViewInit(): void {
    this.listener();
    this.compareWidthToolbar();
  }

  listener(): void {
    this.scrollbarRef.horizontalScrolled.pipe(debounceTime(100), takeWhile(() => !this.destroy)).subscribe(async (e) => {
      this.showNextArrow = !(this.scrollbarRef.viewport.scrollLeft >= (this.scrollbarRef.viewport.scrollMaxX - 10));
      this.showPrevArrow = this.scrollbarRef.viewport.scrollLeft >= 10;

      if (this.scrollbarRef.viewport.scrollLeft === 0) {
        this.showPrevArrow = false;
      }
    });
  }

  /**
   * Compara el tamaño del toolbar para determinar si mostrar los botones de siguiente y atras
   */
  compareWidthToolbar(): void {
    this.showNextArrow = this.scrollbarRef.viewport.nativeElement.offsetWidth < this.toolbarContent.nativeElement.offsetWidth;
    this.showPrevArrow = this.scrollbarRef.viewport.scrollLeft >= 10;

    // this.showPrevArrow = this.scrollbarRef.viewport.scrollLeft >= 10;
    // this.scrollbarRef.horizontalScrolled.pipe(debounceTime(500)).subscribe(async (e) => {
    //   this.showNextArrow = !(this.scrollbarRef.viewport.scrollLeft >= (this.scrollbarRef.viewport.scrollMaxX - 40));
    //   this.showPrevArrow = this.scrollbarRef.viewport.scrollLeft >= 10;
    //
    //   if (this.scrollbarRef.viewport.scrollLeft === 0) {
    //     this.showPrevArrow = false;
    //   }
    // });
  }

  /**
   * Use for view SMAE steps
   * @param selected visible or hide button
   */
  onEmitViewSMAESteps(selected: boolean): void {
    this.viewSMAESteps = selected;
    this.emitViewSMAESteps.emit(selected);
  }

  /**
   * emit
   * @param mealPlanType type
   */
  onChangeMealPlanType(mealPlanType: MealPlanTypeEnum): void {
    if (mealPlanType === this.mealPlanType.selected) return;

    this.modal.confirm({
      nzTitle: '¿Estás seguro de cambiar el tipo de plan de alimentación?',
      nzContent: 'Todos los periodos del plan alimenticio actual cambiarán su distribución de macronutrientes, tomando los valores establecidos ahora por el plan alimenticio tipo ' +
        mealPlanType === MealPlanTypeEnum.SMAE ? 'SMAE' : 'Internacional',
      nzOkText: 'SÍ QUIERO CAMBIAR',
      nzCancelText: 'NO QUIERO',
      nzOkDanger: false,
      nzClassName: 'modal-confirm',
      nzClosable: false,
      nzOnOk: () => {
        this.mealPlanType.selected = mealPlanType;
        this.emitMealPlanType.emit(mealPlanType);
      },
      nzOnCancel: () => {
      }
    });
  }

  /**
   * Select template plan type
   * @param type TemplatePlanTypeEnum
   */
  onSelectTemplatePlanType(type: TemplatePlanTypeEnum): void {
    if (type === this.templatePlanTypeSelected) return;

    this.nzModalService.confirm({
      nzTitle: '¿Deseas cambiar la plantilla?',
      nzContent: 'Si cambias la plantilla perderás los datos que tengas en el plan. ¿Deseas continuar?',
      nzOkText: 'Sí, cambiar plantilla',
      nzCancelText: 'NO',
      nzOkDanger: true,
      nzClassName: 'modal-confirm',
      nzClosable: false,
      nzOnOk: async () => {
        this.templatePlanTypeSelected = type;
        this.emitTemplatePlanType.emit(type);
      },
      nzOnCancel: () => {
      }
    });
  }

  async onNext(): Promise<void> {
    await this.scrollbarRef.scrollTo({
      left: this.scrollbarRef.viewport.scrollLeft + 70,
      duration: 300,
    });
    if (this.scrollbarRef.viewport.scrollLeft >= (this.scrollbarRef.viewport.scrollMaxX - 10)) {
      this.showNextArrow = false;
    }
    this.showPrevArrow = this.scrollbarRef.viewport.scrollLeft >= 10;
  }

  async onPrev(): Promise<void> {
    await this.scrollbarRef.scrollTo({
      left: this.scrollbarRef.viewport.scrollLeft - 70,
      duration: 300,
    });
    if (this.scrollbarRef.viewport.scrollLeft === 0) {
      this.showPrevArrow = false;
    }
    this.showNextArrow = this.scrollbarRef.viewport.nativeElement.offsetWidth < this.toolbarContent.nativeElement.offsetWidth;
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    if (this.timeOutResize) {
      clearTimeout(this.timeOutResize);
    }
    this.timeOutResize = setTimeout(() => {
      this.compareWidthToolbar();
    }, 300);
  }

  getDeviceDesktop(): boolean {
    const deviceType: DeviceTypeEnum = this.utilitiesService.getDeviceType();
    return deviceType === DeviceTypeEnum.DESKTOP;
  }

  ngOnDestroy(): void {
    this.destroy = true;
  }

  get hasValueOnSmaeTable(): boolean {
    return Object.values(this.categoryIngredientsCount).some((value) => (value.valueSmaeTable > 0 || value.smaePortion > 0));
  }

  onViewPeriods(): void {
    this.emitSMAEViewPeriods.emit(true);
  }

}
